import { I18nFormProvider, useDynamicConfig } from "@dgs/core";
import { Form, Formik } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, Route, Routes } from "react-router";
import styled from "styled-components";
import { EventFormValues, EventSaveRequest } from "../../types/event";
import { EventAddressStep } from "./EventAddressStep";
import { EventBaseDataStep } from "./EventBaseDataStep";
import { EventDetailsStep } from "./EventDetailsStep";
import { mapEventFormValuesToRequest } from "./eventFormUtils";
import { EventParticipationStep } from "./EventParticipationStep";
import { EventPlannedCostStep } from "./EventPlannedCostStep";
import { EventStepper } from "./EventStepper";
import { EventUsersStep } from "./EventUsersStep";
import { validateEventForm } from "./eventValidation";

const StyledForm = styled(Form)`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacing(6)};
`;

interface Props {
	variant?: "elevated" | "outlined";
	initialValues: EventFormValues;
	onSubmit: (saveRequest: EventSaveRequest) => Promise<void>;
}

export const SaveEvent: FC<Props> = ({ initialValues, onSubmit, variant }) => {
	const { t } = useTranslation();
	const { languageSettings } = useDynamicConfig();

	return (
		<I18nFormProvider initialLanguage={languageSettings.fallback}>
			<Formik
				initialValues={initialValues}
				onSubmit={async (values) => {
					return onSubmit(mapEventFormValuesToRequest(values));
				}}
				validate={validateEventForm(t)}
				validateOnMount={true}
			>
				<StyledForm>
					<EventStepper />
					<Routes>
						<Route index element={<Navigate to="base-data" replace />} />
						<Route path="base-data" element={<EventBaseDataStep variant={variant} />} />
						<Route path="address" element={<EventAddressStep variant={variant} />} />
						<Route path="users" element={<EventUsersStep variant={variant} />} />
						<Route path="participation" element={<EventParticipationStep variant={variant} />} />
						<Route path="planned-cost" element={<EventPlannedCostStep variant={variant} />} />
						<Route path="details" element={<EventDetailsStep variant={variant} />} />
					</Routes>
				</StyledForm>
			</Formik>
		</I18nFormProvider>
	);
};
